/**
 * The Worker serves this bundle and the API from the same origin in
 * production, and the Vite dev proxy reproduces that locally — so every
 * request is same-origin and relative paths are always correct.
 */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set("Accept", "application/json");
  if (init.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const res = await fetch(path, {
    ...init,
    headers,
    // Same-origin, but explicit: the session cookie is the whole auth story.
    credentials: "same-origin",
  });

  const body = await res.json().catch(() => null);

  if (!res.ok) {
    throw new ApiError(
      res.status,
      (body as { error?: string } | null)?.error ?? "unknown_error",
      (body as { message?: string } | null)?.message ?? res.statusText,
    );
  }

  return body as T;
}
